var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndustriesAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.8335 7H8.16683",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8335 4.66602H8.16683",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16683 12.2507V10.5007C8.16683 10.1912 8.04391 9.89449 7.82512 9.67569C7.60633 9.4569 7.30958 9.33398 7.00016 9.33398C6.69074 9.33398 6.394 9.4569 6.17521 9.67569C5.95641 9.89449 5.8335 10.1912 5.8335 10.5007V12.2507",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.49984 5.83398H2.33317C2.02375 5.83398 1.72701 5.9569 1.50821 6.17569C1.28942 6.39449 1.1665 6.69123 1.1665 7.00065V11.084C1.1665 11.3934 1.28942 11.6902 1.50821 11.9089C1.72701 12.1277 2.02375 12.2507 2.33317 12.2507H11.6665C11.9759 12.2507 12.2727 12.1277 12.4915 11.9089C12.7103 11.6902 12.8332 11.3934 12.8332 11.084V5.25065C12.8332 4.94123 12.7103 4.64449 12.4915 4.42569C12.2727 4.2069 11.9759 4.08398 11.6665 4.08398H10.4998",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 12.25V2.91667C3.5 2.60725 3.62292 2.3105 3.84171 2.09171C4.0605 1.87292 4.35725 1.75 4.66667 1.75H9.33333C9.64275 1.75 9.9395 1.87292 10.1583 2.09171C10.3771 2.3105 10.5 2.60725 10.5 2.91667V12.25",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustriesAi);
export default __webpack_public_path__ + "static/media/industriesAI.739d610c2f63d7368a33def0e894164b.svg";
export { ForwardRef as ReactComponent };